<mat-icon *ngIf="alert?.message?.files != null">attach_file</mat-icon>
<mat-icon *ngIf="alert?.location?.point">location_on</mat-icon>
<mat-icon *ngIf="alert?.location?.areas?.length">map</mat-icon>
<mat-icon *ngIf="alert?.location?.facilities?.length === 1">domain</mat-icon>
<mat-icon *ngIf="alert?.location?.facilities?.length > 1">location_city</mat-icon>
<mat-icon *ngIf="alert?.weatherAlert">cloud</mat-icon>
<mat-icon *ngIf="alert?.message?.severityAssessment != null">done</mat-icon>